
    <h1 mat-dialog-title>Changer mot de passe</h1>
    <mat-divider></mat-divider>
    <br />
    <form #passwordForm="ngForm" name="form">
        <div mat-dialog-content style="background-color: rgba(255, 255, 255, 0.548)">
            <mat-form-field>
                <input matInput type="password" name="oldPassword" [(ngModel)]="model.oldPassword" placeholder="ancien mot de passe" required />
            </mat-form-field><br>
            <mat-form-field>
                <input matInput type="password" name="newPassword" [(ngModel)]="model.newPassword" placeholder="nouveau mot de passe" required />
            </mat-form-field><br>
            <mat-form-field>
                <input matInput type = "password" name="confirmPassword" [(ngModel)]="model.confirmPassword" placeholder="confirmer mot de passe" required />
             </mat-form-field>
        </div>
    </form>
    <br />
    <mat-divider></mat-divider>
    <mat-dialog-actions align="end">
        <button mat-button color="danger" mat-dialog-close>Fermer</button>
        <button mat-button color="primary"
         (click)="reset()" [disabled]="!passwordForm.form.valid" cdkFocusInitial>Modifier</button>
      </mat-dialog-actions>


<!-- Copyright 2019 Google LLC. All Rights Reserved.
    Use of this source code is governed by an MIT-style license that
    can be found in the LICENSE file at http://angular.io/license -->
